import { render } from "./NewCity.vue?vue&type=template&id=39a1231a"
import script from "./NewCity.vue?vue&type=script&lang=js"
export * from "./NewCity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__